'use client';
import { sendGTMEvent } from '@/modules/common/services/sendGTMEvent';
import { DATA_LAYER_EVENTS } from '@/modules/product/services/data-layer-events/events';

type VirtualPageViewDataLayerEventArgs = {
  pathname: string;
  referrer: string | null;
  content_group: string | null;
  content_group2: string | null;
  content_group3: string | null;
  title: string;
  author?: string | null;
  brand_id?: string | null;
  colors?: string[] | null;
  style?: string | null;
};

export function virtualPageViewDataLayerEvent({
  pathname,
  referrer,
  content_group,
  content_group2,
  content_group3,
  title,
  author = null,
  brand_id = null,
  colors = null,
  style = null,
}: VirtualPageViewDataLayerEventArgs) {
  if (typeof window === 'undefined') {
    return;
  }

  sendGTMEvent({
    event: DATA_LAYER_EVENTS.virtual_page_view,
    page: {
      title,
      path: pathname,
      queries: window.location.search,
      hostname: window.location.hostname,
      location: window.location.href,
      referrer: referrer,
      content_group: content_group,
      content_group2: content_group2,
      content_group3: content_group3,
      author,
      ...(brand_id && { brand_id }),
      ...(colors && colors.length > 0 && { colors }),
      ...(style && { style }),
    },
  });
}
